import React, { useState } from "react";
import ErrorHandlerProvider from "./ErrorHandlerProvider";
import ErrorDialog from "../../components/ErrorDialog";

export default (props: any) => {
  const [error, setError] = useState<any>();
  const [errorTitle, setErrorTitle] = useState<string>();
  const [action, setAction] = useState<() => void>();

  if (error) {
    console.error(
      "An error has been thrown",
      errorTitle,
      JSON.stringify(error)
    );
  }

  return (
    <ErrorHandlerProvider
      fred="2"
      callback={(title: string, err: any, action?: () => void) => {
        console.error("ERROR RAISED ");
        console.error("Error title: ", title);
        console.error("Error content", JSON.stringify(err));
        setError(err);
        setErrorTitle(title);
        setAction(action);
      }}
    >
      {props.children}

      {error && (
        <ErrorDialog
          title={errorTitle}
          onClose={() => {
            setError(null);
            setErrorTitle("");
          }}
          action={action}
          error={JSON.stringify(error, null, 2)}
        />
      )}
    </ErrorHandlerProvider>
  );
};
